import React, { useEffect, useState } from 'react';

// Local Resources
import { ANALYSIS_TYPE, MeasurementStatetoHTML, AnalysisResultToIconState } from '../enums';

// MaterialUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

// Tippy.JS Resources
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/shift-away.css';

// Default image size parameters
const defaultWidth = 64;
const defaultHeight = 70;

function BuildPopover(ambientState, tempsState) {

	let ambientTemp = MeasurementStatetoHTML('Ambient', ambientState, ANALYSIS_TYPE.TEMPERATURE);
	let tempSensors = tempsState.map((temp, index) => {
		return MeasurementStatetoHTML(`Sensor ${temp.temp_sensor}`, temp.status, ANALYSIS_TYPE.TEMPERATURE);
	});

	return (
		<span
			style={{
				fontFamily: 'Saira, sans-serif',
				fontWeight: '600'
			}}
		>
			<p><b>Temperatures</b></p>
			{ambientTemp}<br />
			<br />
			{tempSensors.map((temp) => {
				return <span>{temp}<br /></span>;
			})}
		</span>
	);
}

export default function TempIcon(props) {

	const {ambientState, tempsState, onClick, scale = 1.0} = props;

	const state = AnalysisResultToIconState(ambientState.result);
	const imgPath = `/images/batterymap_icons/temp_${state}.svg`;

	const popover = BuildPopover(ambientState, tempsState)

	return (
		<Tippy
			content={popover}
			placement="bottom"
			animation="shift-away"
		>
			<Button
				sx={{
					padding: 0,
					margin: '3px',
				}}
				onClick={() => onClick()}
			>
				<Box
					border='solid'
					borderRadius={0.75}
					borderColor='#FFFFFF11'
					bgcolor='#FFFFFF22'
					padding='3px'
					margin='1px'
					sx={{
						borderWidth: '1px',
						'&:hover': {
							color: '#FFFFFF',
							backgroundColor: '#FFFFFF44',
						},
					}}
				>
					<img src={imgPath} width={defaultWidth * scale} height={defaultHeight * scale} alt={`temp icon`} />
					<Typography
						fontFamily='Helvetica Neue LT Std Roman, sans-serif'
						color='#FFFFFF'
						align='center'
						sx={{ fontSize: `calc(1rem * ${scale})` }}
					>
						Temps
					</Typography>
				</Box>
			</Button>
		</Tippy>
	);
}